import firebase from 'firebase'
import {mediaRef} from '@/firebase_config'

export default {
  data () {
    return {
      loading: false,
      url: null,
      thumbSize: 2000,
      media: null
    }
  },
  firebase () {
    return {
      mediaRef: mediaRef
    }
  },
  methods: {
    getCurrent () {
      if (this.mediaId) {
        mediaRef.child(this.mediaId).once('value', snapshot => {
          this.media = snapshot.val()
        })
      }
    },
    getImgUrl () {
      let imagePath = this.media.name
      let storage = firebase.storage().ref()
      let imageRef = storage.child('thumbs/' + imagePath + '_' + this.thumbSize + '_thumb.jpg')
      imageRef.getDownloadURL()
        .then(
          (url) => {
            this.loading = false
            this.url = url
          },
          (error) => {
            switch (error.code) {
              case 'storage/object_not_found':
                console.log('File doesn\'t exist')
                break
              case 'storage/unauthorized':
                console.log('User doesn\'t have permission to access the object')
                break
              case 'storage/canceled':
                console.log('User canceled the upload')
                break
              case 'storage/unknown':
                console.log('Unknown error occurred, inspect the server response')
                break
            }
            this.loading = false
            this.error = error
          }
        )
    }
  },
  watch: {
    mediaId () {
      this.getCurrent()
    },
    media (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getImgUrl()
      }
    }
  },
  mounted () {
    this.getCurrent()
  }
}



// WEBPACK FOOTER //
// ./src/mixins/featuredImage.js